"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReportDataFile = exports.getSummaryDataFile = exports.getDataDirectory = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getDataDirectory = function getDataDirectory(url) {
  return _axios.default.get(url, {
    params: {
      ts: (0, _moment.default)().unix().toString()
    }
  }).then(function (response) {
    return response.data;
  });
};

exports.getDataDirectory = getDataDirectory;

var getSummaryDataFile = function getSummaryDataFile(url) {
  return _axios.default.get(url).then(function (response) {
    return response.data.summaryFileData;
  });
};

exports.getSummaryDataFile = getSummaryDataFile;

var getReportDataFile = function getReportDataFile(reportName, url, metadata) {
  return _axios.default.get(url).then(function (response) {
    return _objectSpread(_objectSpread({}, response.data), {}, {
      reportName: reportName,
      metadata: metadata
    });
  });
};

exports.getReportDataFile = getReportDataFile;